export default {
    error: "Si è verificato un problema durante il recupero degli ordini. Aggiorna il browser.",
    meta: {
        default: "Ordini",
        my_orders: "I miei ordini",
        my_gear: "Ricevuto"
    },
    loadMore: "Carica altro",
    noOrders: "Nessun ordine",
    order: {
        product: {
            title: "Ordine",
            tracking: "Monitoraggio",
            quantity: "Quantità",
            transfer: {
                sender: "Proprietario precedente",
                receiver: "Ricevitore",
                transferrer: "Trasferitore",
                system: "Servizio di assistenza"
            },
            control: {
                cancel: {
                    cta: "Clicca per annullare",
                    tooltip: "Clicca per annullare questo articolo",
                    message: "Abbiamo annullato il tuo ordine."
                },
                cancelRequest: {
                    cta: "Richiesta di annullamento",
                    tooltip: "Clicca per inviare una richiesta di cancellazione"
                },
                received: {
                    cta: "Contrassegna come ricevuto",
                    tooltip: "Clicca per confermare la consegna",
                    message: "Grazie per aver confermato di aver ricevuto il prodotto."
                },
                notReceived: {
                    cta: "Contrassegna come non ricevuto",
                    tooltip: "Clicca per confermare la mancata consegna"
                },
                damaged: {
                    cta: "Contrassegna come danneggiato/rotto",
                    tooltip: "Fai clic per creare un ticket di supporto"
                },
                hide: {
                    cta: "Nascondi elemento",
                    tooltip: "Fare clic per nascondere l'elemento dall'elenco"
                },
                transfer: {
                    cta: "Trasferire",
                    tooltip: "Fai clic per trasferire l'articolo ad un altro dipendente"
                }
            },
            requestToCancelInfo: "Contatteremo il fornitore per richiedere una cancellazione. Si prega di notare che questa è solo una richiesta e la cancellazione potrebbe non essere possibile. Una volta che possiamo determinare se può essere annullata o meno, vi faremo sapere.",
            cancelOk: "OK",
            reason: "Motivo",
            orderedBy: "Ordinato da",
            model: {
                cancel: {
                    reason: {
                        label: "Motivi di cancellazione",
                        placeholder: "Motivi di cancellazione"
                    }
                }
            },
            buttons: {
                cancel: {
                    submit: {
                        cta: "Invia",
                        processing: "Invio"
                    },
                    cancel: {
                        cta: "Cancellare"
                    }
                }
            }
        }
    },
    help: {
        text: "<p>Hai domande sul tuo ordine?<br/> Consulta il nostro <a href='#' role='button' data-widget-trigger='{widgetOptions}'><b>Centro di supporto</b></a> per ricevere assistenza</p><p> Hai bisogno di un prodotto non presente nell'elenco?<br/> Clicca <a href='#' role='button' data-widget-trigger='{widgetOptions}'><b>qui</b></a> per inviare un suggerimento</p>",
        email: {
            subject: ""
        }
    }
}